module.exports = __webpack_public_path__ + "static/media/Callie.594e78f5.jpg";